import type { Request, Response } from "./_type";

import { usePost } from "~/common/hooks";

/** useAuthService */
export const useAuthService = () => {
  /** URL */
  const url = `/auth/agent`;

  /** return */
  return usePost<Request, Response>(url, {
    showError: false,
  });
};
